<script setup lang="ts">
/**
 * リプライ追加表示ボタン。
 */

import { defineProps, defineEmits } from "vue";

interface Props {
	/**
	 * 「追加表示ボタン内部」文言
	 */
	moreButtonDisplayName: string;
	/**
	 * リプライの追加表示APIリクエスト中かどうか。
	 */
	isProcessingGetMoreReply: boolean;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();

interface Emits {
	(e: "on-click-more-button"): void;
}
const emit = defineEmits<Emits>();
const onclick = (): void => {
	emit("on-click-more-button");
};
</script>

<template>
	<div class="revico-community-talk-reply-more-button-wrapper">
		<button type="button" class="revico-community-talk-reply-more-button" @click="onclick" :disabled="isProcessingGetMoreReply">{{ moreButtonDisplayName }}</button>
	</div>
</template>

<style lang="scss">
.revico-widget .revico-community-talk .revico-community-talk {
	&-reply-more-button-wrapper {
		padding: 20px;
		text-align: center;
	}

	&-reply-more-button {
		@include resetButton;
		width: 60%;
		padding: 8px;
		color: white;
		background-color: var(--accent-color);
	}
}
</style>
